import styled, { css } from 'styled-components';
import { Close as CloseIcon } from '@mui/icons-material';
import { ContainerSection } from '../styles';
import { KOGMediaQuery } from '@/main/services/utilsLayout';

export const Container = styled(ContainerSection)``;

export const ContainerScroll = styled(ContainerSection)`
  max-height: 390px;
  overflow-y: auto;
`;

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;

  gap: 10px;
  overflow: hidden;

  @media (max-width: 426px) {
  display: grid;
    grid-template-columns: 1fr;

    button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }
  }
`;

export const HeaderText = styled.h4`
  color: #000;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1rem;
  margin-right: 1rem;
`;

export const IconClose = styled(CloseIcon)`
  &&& {
    cursor: pointer;
  }
`;


export const AreaFilterGrid = styled.div`
  margin-left: auto;
  margin-right: 1rem;

  &&& {
    .MuiFormControl-root {
      margin: -04px 0 0 0;
    }
  }

  ${({ theme }) =>
    KOGMediaQuery({
      breakpoint: theme.breakpoints.mobile,
      styles: css`
        width: 100%;
        margin: 0;
      `
    })}
`;